import {
  ClientReportDetailSection,
  ClientReportHeaderSection,
  StyledActivityCardBackground
} from 'modules';
import React from 'react';



export type ClientReportActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const ClientReportActivity = (props: ClientReportActivityProps) => {

  return (
    <StyledActivityCardBackground.FC>
      <ClientReportHeaderSection.FC />
      <ClientReportDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
